import { Skeleton } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

export const AdminTableLoader = () => {
	return (
		<div className={styles.admin_table_loader}>
			<div className={styles.admin_table_loader__main}>
				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '237px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '302px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '280px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '296px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '252px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '302px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '296px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '252px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '675px', height: '20px' }} />
				</div>
			</div>
			<div className={styles.admin_table_loader__footer}>
				<Skeleton style={{ maxWidth: '322px', height: '36px' }} />
				<Skeleton style={{ maxWidth: '64px', height: '36px' }} />
			</div>
		</div>
	);
};
